import { render } from "./PackagesView.vue?vue&type=template&id=2c683b26&scoped=true"
import script from "./PackagesView.vue?vue&type=script&lang=js"
export * from "./PackagesView.vue?vue&type=script&lang=js"

import "./PackagesView.vue?vue&type=style&index=0&id=2c683b26&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c683b26"]])

export default __exports__